import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App";
import { AuthProvider } from "./auth";
import "./styles.css";

/**
 * Tailwind emits the design tokens as custom properties at build time, so
 * nothing has to install them at runtime any more — importing the stylesheet
 * is what puts `--color-canvas` and the rest on `:root`.
 */

/**
 * Server state defaults.
 *
 * The portal is a control panel for work happening elsewhere: a Run advances
 * whether or not this tab is looking at it. So refetching when a tab regains
 * focus is the correct default here — it is the cheapest way to stop showing a
 * stale phase to someone who just came back. Retries stay off, because the API
 * reports failures as deliberate machine codes that screens render; silently
 * re-issuing a rejected request would only delay showing the reason.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: false,
    },
    mutations: {
      retry: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
